module.exports = __webpack_public_path__ + "media/img/user6-128x128-c2bdffc0.jpg";